/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./Home.css";
import {
  Flex,
  Card,
  Text,
  Box,
  Heading,
  TextField,
  ScrollArea,
} from "@radix-ui/themes";

import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { getAllDashboardData } from "../../Services/DashboardApi";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { PieChart } from "@mui/x-charts/PieChart";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const { setloader, initAlert } = GeneralContextFunc();
  const [dashboard, setDashBoard] = useState({});
  const [pieChartData, setPieChartData] = useState([]);
  useEffect(() => {
    setloader(true);
    getAllDashboardData()
      .then((res) => {
        setDashBoard(res.data);
        let resData = res?.data?.topCampaign;
        setPieChartData([
          ...Object.entries(resData).map(([key, Value]) => {
            let label = `${key} ${Value}`;
            return {
              value: Value,
              label: label < 20 ? label : `${label.slice(0, 20)} ...`,
            };
          }),
        ]);
        // initAlert(res?.message);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        console.log("error", err);
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  }, []);

  return (
    <div className="homePage">
      <Heading mt="1.5rem" weight="bold" align="left" size="8">
        Dashboard
      </Heading>
      <Flex justify="between" className="submenu" mt="1.5rem" height="3.1rem">
        <Flex align="center" gapX="1.5rem">
          <Text size="3" weight="medium">
            Overview
          </Text>
          <Text size="3" weight="medium">
            Reports
          </Text>
        </Flex>
        <div className="searchBoxHome">
          <TextField.Root
            className="searchHomeField"
            variant="soft"
            size="3"
            placeholder="Search"
          >
            <TextField.Slot>
              <MagnifyingGlassIcon height="1.5rem" width="1.5rem" />
            </TextField.Slot>
          </TextField.Root>
        </div>
      </Flex>
      <Flex justify="center" gapX="1.5rem" mt="1.5rem" maxHeight="5rem">
        <Card className="card">
          <Box className="boxes">
            <Text size="3" color="gray" weight="regular" as="div">
              Campaigns
            </Text>
            <Text size="6" weight="bold" as="div">
              {dashboard.campaigns}
            </Text>
          </Box>
        </Card>
        <Card className="card">
          <Box className="boxes">
            <Text size="3" color="gray" weight="regular" as="div">
              Viewed - view detailed page
            </Text>
            <Text size="6" weight="bold" as="div">
              {dashboard.views}
            </Text>
          </Box>
        </Card>
        <Card className="card">
          <Box className="boxes">
            <Text size="3" color="gray" weight="regular" as="div">
              Total donation
            </Text>
            <Text size="6" weight="bold" as="div">
              $ {dashboard.totalDonation}
            </Text>
          </Box>
        </Card>
      </Flex>
      <Flex mt="1.5rem" gapX="1.5rem" align="start" justify="between">
        <Card className="cards">
          <Box>
            <Text size="4" weight="bold">
              Users by City
            </Text>
            <ScrollArea
              style={{ maxHeight: "320px" }}
              type="hover"
              scrollbars="vertical"
              mt="4"
            >
              {dashboard?.viewsByCity
                ? dashboard?.viewsByCity.map((data, i) => (
                    <Flex
                      mt="4"
                      key={i}
                      wrap="wrap"
                      width="100%"
                      justify="between"
                    >
                      <Text size="3" as="div">
                        {data.cityName}
                      </Text>
                      <div>
                        <Text size="3" mr="5">
                          {data.percentage}%
                        </Text>
                        <Text size="3" color="gray">
                          {data.count}
                        </Text>
                      </div>
                    </Flex>
                  ))
                : ""}
            </ScrollArea>
          </Box>
        </Card>
        <Card className="cards">
          <Box width="556px">
            <Text size="4" weight="bold">
              Top 5 Campaign
            </Text>
            <Box mt="3">
              {pieChartData.length ? (
                <PieChart
                  series={[
                    {
                      data: pieChartData,
                      cx: 120,
                      innerRadius: 60,
                      cornerRadius: 4,
                    },
                  ]}
                  width={480}
                  height={200}
                />
              ) : (
                <Text as="div" weight="medium" size="5">
                  No data found
                </Text>
              )}
            </Box>
          </Box>
        </Card>
      </Flex>
    </div>
  );
};

export default Home;
